import axios, { AxiosInstance } from 'axios'

export interface SearchResultProps {
  data: {
    article: string
    createdAt: string
    is_qa_art: boolean | null
    publishedAt: string
    qa_art: null
    slug: string
    title: string
    updatedAt: string
  }[]
  pageNum: number
  pageSize: number
  total: number
}

export const searchPageSize = 10

class SearchServices {
  private instance: AxiosInstance

  constructor() {
    this.instance = axios.create()
  }

  public searchNews(slug: string, page: number) {
    const params = {
      index: 'fox-support',
      keyword: slug,
      lang: 'en-US',
      pageSize: searchPageSize,
      pageNum: page,
      fields: ['title', 'article'],
      sort: [{ _score: 'desc' }, { createdAt: 'desc' }],
    }
    return this.instance.post<SearchResultProps>('/strapi-search-center', params)
  }
}

export const searchInstance = new SearchServices()
